import React, { useContext } from 'react';
import { Icon, IconName, Text } from '@usealloy/component-library';
import { InfoIconContainer, TagDescriptionContainer } from './styles';
import { RuleBuilderContext } from '../RuleBuilderContainer/context';
import { ContainerType } from '../types';

const TagDescription = () => {
  const { sourceAction, containerType } = useContext(RuleBuilderContext);
  const {
    sourceAction: ruleEditorSourceAction,
    containerType: ruleEditorContainerType,
  } = useContext(RuleBuilderContext);

  const action = sourceAction || ruleEditorSourceAction;

  if (!(action?.tag)) {
    return null;
  }

  const isTooltip = containerType === ContainerType.TOOLTIP
    || ruleEditorContainerType === ContainerType.TOOLTIP;

  return (
    <TagDescriptionContainer isTooltip={isTooltip}>
      <InfoIconContainer>
        <Icon icon={IconName.Info} size="small" />
      </InfoIconContainer>
      <Text style={{ color: 'var(--cl-text-secondary)' }}>{action.tag.description}</Text>
    </TagDescriptionContainer>
  );
};

export default TagDescription;
